var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{ name: 'building', params: { buildingId: _vm.building.id }}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.building.name)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.building.zip)+" "+_vm._s(_vm.building.locality)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }